<ng-select
  #select
  (scrollToEnd)="onScrollEnd()"
  [addTag]="addTag"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [class.ng-select-readonly]="readonly"
  [clearable]="clearable"
  [dropdownPosition]="dropdownPosition"
  [formControl]="control"
  [groupBy]="groupBy"
  [items]="items"
  [loading]="loading"
  [maxSelectedItems]="maxSelectedItems"
  [minTermLength]="0"
  [multiple]="multiple"
  [ngClass]="type"
  [placeholder]="placeholder"
  [readonly]="readonly"
  [searchable]="searchable"
  [trackByFn]="trackByFn"
  [typeToSearchText]="typeToSearchText"
  [typeahead]="typeahead"
  [virtualScroll]="virtualScroll"
  class="ng-select-sh"
>
  <ng-template *ngIf="searchInList" ng-header-tmp>
    <input
      (input)="onFilter($event)"
      [placeholder]="typeToSearchText"
      autocomplete="off"
      class="search-input"
      type="search"
    />
  </ng-template>
  <ng-template let-clear="clear" let-item="item" ng-label-tmp>
    <ng-container *ngIf="icon">
      <svg-icon [src]="iconPath" class="select-icon"></svg-icon>
    </ng-container>
    <ng-container *ngIf="bindLabel && item">
      <svg-icon *ngIf="item.icon" [src]="'/assets/icons/' + item.icon + '.svg'" class="option-icon"></svg-icon>
      <span class="ng-value-label">
        {{ (differentDisplayName ? item[differentDisplayName] ?? item[bindLabel] : item[bindLabel]) | translate }}
      </span>
    </ng-container>
    <ng-container *ngIf="!bindLabel">
      <span class="ng-value-label">{{ item | translate }}</span>
    </ng-container>
    <div *ngIf="arrow && !multiple" class="arrow">
      <svg-icon class="arrow-icon" src="/assets/icons/icons-arrow-down.svg"></svg-icon>
    </div>
    <ng-container *ngIf="multiple">
      <span (click)="clear(item)" aria-hidden="true" class="ng-value-clear">
        <svg-icon class="arrow-icon" src="/assets/icons/icons-close-small.svg"></svg-icon>
      </span>
    </ng-container>
  </ng-template>
  <ng-template let-index="index" let-item="item" ng-option-tmp>
    <div [class.is-locked]="item?.isLocked && item?.disabled" class="option">
      <img *ngIf="item?.icon && useImgInsteadSvgIcon" [src]="'/assets/icons/' + item.icon + '.svg'" alt="icon" />
      <svg-icon
        *ngIf="item?.icon && !useImgInsteadSvgIcon"
        [src]="'/assets/icons/' + item.icon + '.svg'"
        class="option-icon"
      ></svg-icon>
      <div *ngIf="bindLabel && item" class="ng-option-label">
        <span class="option-label">{{ item[bindLabel] | translate }}</span>
      </div>
      <div *ngIf="!bindLabel" class="ng-option-label">
        <span>{{ item | translate }}</span>
      </div>
      <svg-icon class="ng-option-checkmark" src="/assets/icons/icons-checkmark.svg"></svg-icon>
      <svg-icon
        *ngIf="item?.emptyRequiredFields"
        [tippyProps]="{ duration: [500, 500], offset: [0, 7], delay: [0, 0], animation: 'scale', placement: 'right' }"
        class="warning-icon"
        ngxTippy="{{ 'SH.MISSING_REQUIRED_CONTENT' | translate }}"
        src="/assets/icons/icons-warning-filled.svg"
        tippyClassName="tippy-right"
      ></svg-icon>
      <div (click)="onItemClick(item)" *ngIf="clearSelected" class="clear"></div>
    </div>
  </ng-template>
  @if (!!addNewLabel) {
    <ng-template ng-footer-tmp>
      <div class="ng-option" (click)="onAddNew()">
        <div class="option">
          <svg-icon src="/assets/icons/icons-plus.svg" class="option-icon"></svg-icon>
          <div class="ng-option-label">
            <span class="ng-value-label">{{ addNewLabel }}</span>
          </div>
        </div>
      </div>
    </ng-template>
  }
  <ng-template let-item="item" let-tag="searchTerm" ng-tag-tmp>
    <div class="ng-option-label">
      <span>{{ tag }}</span>
    </div>
    <svg-icon class="ng-option-checkmark" src="/assets/icons/icons-checkmark.svg"></svg-icon>
  </ng-template>
</ng-select>
